import { render, staticRenderFns } from "./PaltenCodeList.vue?vue&type=template&id=78e2adb5&scoped=true&"
import script from "./PaltenCodeList.vue?vue&type=script&lang=js&"
export * from "./PaltenCodeList.vue?vue&type=script&lang=js&"
import style0 from "./PaltenCodeList.vue?vue&type=style&index=0&id=78e2adb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2adb5",
  null
  
)

export default component.exports